export default {
  path: 'product_ingredients',
  name: 'product_ingredients',
  component: () => import('@/pages/product/ingredients/list.vue'),
  meta: { title: '产品成分' }
}
